/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('FullMemberDialogController',FullMemberDialogController);

    FullMemberDialogController.$inject = ['$scope', '$uibModalInstance', 'ProfileService', 'DataUtils', '$http', '$rootScope', '$state', 'Principal'];

    function FullMemberDialogController($scope, $uibModalInstance, ProfileService, DataUtils, $http, $rootScope, $state, Principal) {
        var vm = this;
        vm.becomeMember = becomeMember;
        vm.clear = clear;
        vm.calcToPay = calcToPay;
        vm.profile = {};
        vm.profile.isStudent = false;
        vm.errorWrongFormat = null;
        vm.errorMaxUploadSize = null;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.fileSize = null;
        vm.welcomeFee = null;
        vm.anualFee = null;
        vm.toPay = null;
        vm.isSaving = null;
        vm.errorIban = null;
        vm.errorBic = null;
        vm.showFreeYear = false;
        vm.university = false;

        init();

        function init() {
            var d = new Date();
            var n = d.getMonth();
            if(n === 10 || n === 11) {
                vm.showFreeYear = true;
            }
            Principal.identity().then(function(account) {
                vm.account = account;
            });
            vm.calcToPay();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function becomeMember () {
            vm.isSaving = true;
            if(vm.profile.isUsingSepa === true) {
                if(vm.profile.isDeviatedHolder === false) {
                    vm.profile.bankAccountHolder = vm.account.firstName + ' ' + vm.account.lastName;
                }
            } else {
                vm.profile.bankAccountHolder = null;
                vm.profile.iban = null;
                vm.profile.bic = null;
                vm.profile.isDeviatedHolder = false;
            }
            if (!vm.university && !vm.profile.isStudent) {
                vm.profile.university = null;
            }
            $http.post('/api/member/become/', vm.profile, null).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $rootScope.$broadcast('becomeMember');
            $state.go($state.current, {}, {reload: true});
            $uibModalInstance.close();
        }

        function onSaveError (response) {
            vm.isSaving = false;
            if (response.status === 400 && response.data === 'bic') {
                vm.errorBic = 'ERROR';
            } else if (response.status === 400 && response.data === 'iban') {
                vm.errorIban = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
            //$uibModalInstance.close();
        }

        vm.truncateUpload = function() {
            vm.profile.matriculationCertificate = null;
            vm.profile.matriculationCertificateContentType = null;
            vm.errorWrongFormat = false;
            vm.errorMaxUploadSize = false;
        };

        vm.setMatriculationCertificate = function ($file, profile) {
            if ($file) {
                if ($file.type !== 'application/pdf') {
                    vm.errorWrongFormat = true;
                } else {
                    DataUtils.toBase64($file, function(base64Data) {
                        vm.fileSize = vm.byteSize(base64Data).replace(/\s/g, '').replace('bytes', '');
                        if (vm.fileSize > 2097152) {
                            $scope.$apply(function() {
                                vm.errorMaxUploadSize = true;
                            });
                        } else {
                            $scope.$apply(function() {
                                profile.matriculationCertificate = base64Data;
                                profile.matriculationCertificateContentType = $file.type;
                                vm.errorWrongFormat = false;
                                vm.errorMaxUploadSize = false;
                            });
                        }
                    });
                }
            }
        };

        function calcToPay () {
            ProfileService.getProfileInfo().then(function(response) {
                vm.welcomeFeeStudent = response.welcomeMembershipFeeStudent;
                vm.welcomeFeeNormal = response.welcomeMembershipFeeStudentNormal;
                vm.welcomeFee = vm.profile.isStudent ? vm.welcomeFeeStudent : vm.welcomeFeeNormal;
                vm.anualFee = response.anualMembershipFee;
                vm.toPay = vm.welcomeFee + vm.anualFee;
            });
        }

        vm.truncateBancAccount = function() {
            vm.profile.iban = null;
            vm.profile.bic = null;
            vm.profile.bankAccountHolder = null;
            vm.profile.isDeviatedHolder = false;
        };

        vm.truncateBancAccountHolder = function() {
            vm.profile.bankAccountHolder = null;
        };
    }
})();
